<div class="bloco-anexos">
  <!-- O título é o da seção Anexos, no shell. -->
  <p class="bloco-apoio">Internos: não são impressos nem enviados ao cliente.</p>

  @if (!isSomenteLeitura) {
    <app-file-dropzone
      [uploading]="isLendo"
      hint="Qualquer tipo de arquivo · até 2 MB cada"
      uploadingLabel="Lendo arquivos…"
      (filesSelected)="processarArquivos($event)">
    </app-file-dropzone>
  }

  @if (anexos.length) {
    <div class="lista-anexos mt-3">
      @for (anexo of anexos; track anexo; let i = $index) {
        <div class="anexo-item">
          <mat-icon class="anexo-icone material-symbols-outlined">description</mat-icon>

          <div class="anexo-info">
            <span class="anexo-nome">{{ anexo.nomeArquivo }}</span>
            <span class="anexo-meta">
              {{ formatarTamanho(anexo.tamanhoBytes) }}
              @if (!anexo.idVendaAnexo) {
                <span class="anexo-novo">· será enviado ao salvar</span>
              }
            </span>
          </div>

          <div class="anexo-acoes">
            @if (anexo.idVendaAnexo) {
              <button class="icon-mat-symbols-btn" mat-icon-button type="button" matTooltip="Baixar" (click)="baixar(anexo)">
                <mat-icon class="material-symbols-outlined">download</mat-icon>
              </button>
            }
            @if (!isSomenteLeitura) {
              <button class="icon-mat-symbols-btn" mat-icon-button type="button" matTooltip="Remover" (click)="remover(i)">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
              </button>
            }
          </div>
        </div>
      }
    </div>
  } @else if (isSomenteLeitura) {
    <p class="anexo-vazio">Nenhum anexo.</p>
  }
</div>
